import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../i18n';
import type { HomeDisplayRow } from './buildHomeDisplayRows';
import { HomeMobileDisplays } from './HomeMobileDisplays';
import { HomeMobileQuickActions } from './HomeMobileQuickActions';

type HomeMobileProps = {
  onlineCount: number;
  rows: HomeDisplayRow[];
  canManage: boolean;
};

function formatCompanionDate(now = new Date()): string {
  return formatDateTime(now, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).toUpperCase();
}

/** Companion Home — status + act, not the desktop playlist board. */
export function HomeMobile({ onlineCount, rows, canManage }: HomeMobileProps) {
  const { t } = useTranslation('home');
  return (
    <div className="flex flex-col gap-5 lg:hidden" style={{ animation: 'gs-in 260ms ease both' }}>
      <header className="flex items-end justify-between gap-3">
        <div className="min-w-0">
          <p
            className="m-0 text-[11px] font-bold tracking-[0.14em]"
            style={{ color: 'var(--gs-muted)' }}
          >
            {formatCompanionDate()}
          </p>
          <h1
            className="m-0 mt-1 text-[28px] font-extrabold leading-none tracking-[-0.04em]"
            style={{ color: 'var(--gs-ink)' }}
          >
            {t('mobile.title')}
          </h1>
        </div>
        <span
          className="inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-[12px] font-semibold"
          style={{
            color: 'var(--gs-ok)',
            background: 'color-mix(in srgb, var(--gs-ok) 14%, var(--gs-panel))',
          }}
        >
          {t('mobile.online', { online: onlineCount })}
        </span>
      </header>

      {canManage ? <HomeMobileQuickActions /> : null}
      <HomeMobileDisplays rows={rows} />
    </div>
  );
}
